import { Experiment as MarvelExperiment, Variant as MarvelVariant } from '@marvelapp/react-ab-test';
import marvelEmitter from '@marvelapp/react-ab-test/lib/emitter';
import { isWithNonTrailEnabled } from 'imports/checkout/api/helpers';
import { sample } from 'lodash';
import { useEffect } from 'react';
import {
  DOMAIN_WISE_NON_TRAIL_COUNTRY,
  FULLY_NON_TRAIL_COUNTRY,
  NEW_3_PLANS_NON_TRAIL_COUNTRY,
} from '/imports/checkout/api/constants';
import { getCountry } from '/imports/checkout/api/utils';
import { useResponsive } from '/imports/core/api/responsiveContext';
import { useAccount } from 'imports/core/api/accounts/accountContext';

const CheckoutExp = (props) => {
  const currentUser = useAccount();

  if (props?.isR1 || props?.isR2) {
    if (currentUser && currentUser.currentUser?.landingPageVariant !== null) {
      return props.children;
    }
  }

  if (!currentUser) {
    return <ArgentinaAbtest {...props} />;
  }

  return <ArgentinaAbtest {...props} />;
};

const ArgentinaAbtest = (props) => {
  const country = getCountry();
  if (country !== 'AR') return <LebanonAbtest {...props} />;

  return (
    <MarvelExperiment name="exp_argentina_plans">
      <MarvelVariant name="8m4w">
        <LebanonAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="8m5w">
        <LebanonAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="15q8m">
        <LebanonAbtest {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const LebanonAbtest = (props) => {
  const country = getCountry();
  if (country !== 'LB') return <PolandAbtest {...props} />;

  return (
    <MarvelExperiment name="exp_lebanon_plans">
      <MarvelVariant name="8m5w">
        <PolandAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="14q8m">
        <PolandAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="8w11m">
        <PolandAbtest {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const PolandAbtest = (props) => {
  const country = getCountry();
  if (country !== 'PL') return <PhilippinesAbtest {...props} />;

  return (
    <MarvelExperiment name="exp_poland_plans">
      <MarvelVariant name="15m7w">
        <PhilippinesAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="15m7w_day_wise">
        <PhilippinesAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="17m10w">
        <PhilippinesAbtest {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const PhilippinesAbtest = (props) => {
  const country = getCountry();
  if (country !== 'PH') return <ParaguayAbtest {...props} />;
  const activeVars = ['16q5w', '9m5w_day_wise', '9m5w16q', '9m5w16q_day_wise'];
  marvelEmitter.defineVariants('exp_philippines_plans', activeVars);
  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_philippines_plans');

    if (!activeVars.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_philippines_plans', sample(activeVars));
    }
  }, []);

  return (
    <MarvelExperiment name="exp_philippines_plans">
      <MarvelVariant name="16q5w">
        <ParaguayAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="9m5w_day_wise">
        <ParaguayAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="9m5w16q">
        <ParaguayAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="9m5w16q_day_wise">
        <ParaguayAbtest {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const ParaguayAbtest = (props) => {
  const country = getCountry();
  if (country !== 'PY') return <TurkeyPlansAbtest {...props} />;
  return (
    <MarvelExperiment name="exp_paraguay_plans">
      <MarvelVariant name="var_1">
        <TurkeyPlansAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_2">
        <TurkeyPlansAbtest {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const TurkeyPlansAbtest = (props) => {
  const country = getCountry();
  if (country !== 'TR') return <MexicoPlanAbtest {...props} />;
  const activeVars = ['var_2', 'var_3', '10m6w16q'];
  marvelEmitter.defineVariants('exp_turkey_plans', activeVars);
  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_turkey_plans');

    if (!activeVars.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_turkey_plans', sample(activeVars));
    }
  }, []);
  return (
    <MarvelExperiment name="exp_turkey_plans">
      <MarvelVariant name="var_2">
        <MexicoPlanAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_3">
        <MexicoPlanAbtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="10m6w16q">
        <MexicoPlanAbtest {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const MexicoPlanAbtest = (props) => {
  const country = getCountry();
  if (country !== 'MX') return <BrazilPlans {...props} />;
  const activeVars = ['var_1', 'var_2', '10m6w'];
  marvelEmitter.defineVariants('exp_mexico_plans', activeVars);
  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_mexico_plans');

    if (!activeVars.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_mexico_plans', sample(activeVars));
    }
  }, []);
  return (
    <MarvelExperiment name="exp_mexico_plans">
      <MarvelVariant name="var_1">
        <BrazilPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_2">
        <BrazilPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="10m6w">
        <BrazilPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const BrazilPlans = (props) => {
  const country = getCountry();
  if (country !== 'BR') return <SouthAfricaPlans {...props} />;
  const activeVars = ['var_2', '9m4w', '9m4w15q'];
  marvelEmitter.defineVariants('exp_brazil_plans', activeVars);
  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_brazil_plans');

    if (!activeVars.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_brazil_plans', sample(activeVars));
    }
  }, []);
  return (
    <MarvelExperiment name="exp_brazil_plans">
      <MarvelVariant name="var_2">
        <SouthAfricaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="9m4w">
        <SouthAfricaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="9m4w15q">
        <SouthAfricaPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const SouthAfricaPlans = (props) => {
  const country = getCountry();
  if (country !== 'ZA') return <AustraliaPlans {...props} />;
  const activeVars = ['control', 'var_1', 'control_day_wise', 'var_1_day_wise', '9m4w14q_day_wise'];
  marvelEmitter.defineVariants('exp_southafrica_plans', activeVars);
  return (
    <MarvelExperiment name="exp_southafrica_plans">
      <MarvelVariant name="control">
        <AustraliaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_1">
        <AustraliaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="control_day_wise">
        <AustraliaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_1_day_wise">
        <AustraliaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="9m4w14q_day_wise">
        <AustraliaPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const AustraliaPlans = (props) => {
  const country = getCountry();
  if (country !== 'AU') return <CanadaPlans {...props} />;
  const activeVars = ['var_2', 'var_4', '39m10w', '39m10w_day_wise'];

  marvelEmitter.defineVariants('exp_australia_plans', activeVars);
  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_australia_plans');

    if (!activeVars.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_australia_plans', sample(activeVars));
    }
  }, []);
  return (
    <MarvelExperiment name="exp_australia_plans">
      <MarvelVariant name="var_2">
        <CanadaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_4">
        <CanadaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="39m10w">
        <CanadaPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="39m10w_day_wise">
        <CanadaPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const CanadaPlans = (props) => {
  const country = getCountry();
  if (country !== 'CA') return <PeruPlans {...props} />;
  const activeVars = ['9w18m', '7w17m'];

  marvelEmitter.defineVariants('exp_canada_plans', activeVars);
  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_canada_plans');

    if (!activeVars.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_canada_plans', sample(activeVars));
    }
  }, []);
  return (
    <MarvelExperiment name="exp_canada_plans">
      <MarvelVariant name="9w18m">
        <PeruPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="7w17m">
        <PeruPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const PeruPlans = (props) => {
  const country = getCountry();
  if (country !== 'PE') return <UkarineGreccePlans {...props} />;
  const activeVars = ['control', 'var_1'];

  marvelEmitter.defineVariants('exp_peru_plans', activeVars);
  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_peru_plans');

    if (!activeVars.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_peru_plans', sample(activeVars));
    }
  }, []);
  return (
    <MarvelExperiment name="exp_peru_plans">
      <MarvelVariant name="control">
        <UkarineGreccePlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_1">
        <UkarineGreccePlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const UkarineGreccePlans = (props) => {
  const country = getCountry();
  if (country !== 'UA' && country !== 'GR') return <IndonesiaPlans {...props} />;

  const ACTIVE_VARS = {
    UA: ['control', 'var_1', 'var_1_day_wise'],
    GR: ['control', 'var_1'],
  };

  const variants = ACTIVE_VARS[country];
  marvelEmitter.defineVariants('exp_ukraine_greece_plans', variants);

  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_ukraine_greece_planss');

    if (!variants.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_ukraine_greece_plans', sample(variants));
    }
  }, []);
  return (
    <MarvelExperiment name="exp_ukraine_greece_plans">
      {variants.map((variant) => (
        <MarvelVariant key={variant} name={variant}>
          <IndonesiaPlans {...props} />
        </MarvelVariant>
      ))}
    </MarvelExperiment>
  );
};

const IndonesiaPlans = (props) => {
  const country = getCountry();
  if (country !== 'ID') return <AndorraFinlandPlans {...props} />;
  return (
    <MarvelExperiment name="exp_indonesia_plans">
      <MarvelVariant name="control">
        <AndorraFinlandPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_1">
        <AndorraFinlandPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_2">
        <AndorraFinlandPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const AndorraFinlandPlans = (props) => {
  const country = getCountry();
  if (country !== 'AD' && country !== 'FI') return <NewIndianPlans {...props} />;
  const activeVars = ['control', 'var_3'];
  marvelEmitter.defineVariants('exp_andorra_finland_new_plans', activeVars);
  return (
    <MarvelExperiment name="exp_andorra_finland_new_plans">
      <MarvelVariant name="control">
        <NewIndianPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_3">
        <NewIndianPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const NewIndianPlans = (props) => {
  const country = getCountry();
  if (country !== 'IN') return <IsraelPlans {...props} />;
  const activeVars = ['var_1', 'var_2', 'var_1_day_wise'];
  marvelEmitter.defineVariants('exp_new_india_plans', activeVars);
  return (
    <MarvelExperiment name="exp_new_india_plans">
      <MarvelVariant name="var_1">
        <IsraelPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_2">
        <IsraelPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_1_day_wise">
        <IsraelPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const IsraelPlans = (props) => {
  const country = getCountry();
  if (country !== 'IL') return <PakistanPlans {...props} />;
  return (
    <MarvelExperiment name="exp_israel_plans">
      <MarvelVariant name="var_1">
        <PakistanPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_2">
        <PakistanPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="9w24m">
        <PakistanPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const PakistanPlans = (props) => {
  const country = getCountry();
  if (country !== 'PK') return <VietnamPlans {...props} />;
  return (
    <MarvelExperiment name="exp_pakistan_plans">
      <MarvelVariant name="var_1">
        <VietnamPlans {...props} />
      </MarvelVariant>
      <MarvelVariant name="var_2">
        <VietnamPlans {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const VietnamPlans = (props) => {
  const country = getCountry();
  if (country !== 'VN') return <ThreePlansPricingABtest {...props} />;
  const activeVars = ['10m6w', '10m6w_day_wise', '4w9m'];
  marvelEmitter.defineVariants('exp_vietnam_plans', activeVars);
  return (
    <MarvelExperiment name="exp_vietnam_plans">
      <MarvelVariant name="10m6w">
        <ThreePlansPricingABtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="10m6w_day_wise">
        <ThreePlansPricingABtest {...props} />
      </MarvelVariant>
      <MarvelVariant name="4w9m">
        <ThreePlansPricingABtest {...props} />
      </MarvelVariant>
    </MarvelExperiment>
  );
};

const ThreePlansPricingABtest = (props) => {
  const country = getCountry();

  if (!NEW_3_PLANS_NON_TRAIL_COUNTRY.includes(country)) {
    return <NonTrailAbtest {...props} />;
  }

  const ACTIVE_VARS = {
    US: [
      'with_non_trial_1',
      'with_non_trial_3',
      '20m10w',
      'with_non_trial_1_day_wise',
      'with_non_trial_3_day_wise',
      '20m10w_day_wise',
    ],
  };

  const variants = ACTIVE_VARS[country] || ['control'];
  marvelEmitter.defineVariants('exp_three_offer_non_trial_plans', variants);

  useEffect(() => {
    const activeVar = marvelEmitter.getActiveVariant('exp_three_offer_non_trial_plans');

    if (!variants.includes(activeVar)) {
      marvelEmitter.setActiveVariant('exp_three_offer_non_trial_plans', sample(variants));
    }
  }, []);

  return (
    <MarvelExperiment name="exp_three_offer_non_trial_plans">
      {variants.map((variant) => (
        <MarvelVariant key={variant} name={variant}>
          {props.children}
        </MarvelVariant>
      ))}
    </MarvelExperiment>
  );
};

const NonTrailAbtest = (props) => {
  const { isMobile, host } = useResponsive();
  const country = getCountry();
  const withNonTrail = isWithNonTrailEnabled(country, isMobile, host);
  const domainWiseCloseNonTrial = DOMAIN_WISE_NON_TRAIL_COUNTRY[host] || [];
  if (!withNonTrail || FULLY_NON_TRAIL_COUNTRY.includes(country) || domainWiseCloseNonTrial.includes(country))
    return props.children;
  return (
    <MarvelExperiment name="exp_non_trail_offer">
      <MarvelVariant name="control">{props.children}</MarvelVariant>
      <MarvelVariant name="with_non_trail">{props.children}</MarvelVariant>
    </MarvelExperiment>
  );
};

export default CheckoutExp;
